module.exports = __webpack_public_path__ + "static/media/homePageImg.5b1ee4a5.jpg";